import { setIsSigninRequiredForTelemetry } from 'owa-analytics-shared';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

let isSigninRequired: boolean | undefined = undefined;

export function getIsSigninRequired(): boolean {
    return !!isSigninRequired;
}

export function setIsSigninRequired(isSigninNeeded: boolean): void {
    isSigninRequired = isSigninNeeded;
    updateSigninRequiredTelemetryState(isSigninNeeded);
}

export function initializeSigninRequiredTelemetryState(): void {
    updateSigninRequiredTelemetryState(!!isSigninRequired);
}

function updateSigninRequiredTelemetryState(isSigninNeeded: boolean): void {
    setIsSigninRequiredForTelemetry(
        isGlobalFeatureEnabled(
            'auth-authErrorSigninRequiredTelemetry',
            true /* dontThrowErrorIfNotInitialized */
        )
            ? isSigninNeeded
            : undefined
    );
}
